import { Controller } from "@hotwired/stimulus"

// Мобильный off-canvas сайдбар — переключает body.sidebar-open;
// десктопное сворачивание — переключает html.sidebar-collapsed и
// сохраняет состояние в localStorage (см. также инлайн-скрипт в
// layouts/_head.html.slim, который применяет класс до отрисовки, чтобы
// избежать мигания развёрнутого сайдбара при загрузке страницы).
// См. app/assets/stylesheets/design_system/_sidebar.scss
const COLLAPSE_STORAGE_KEY = "kibet:sidebar-collapsed"

export default class extends Controller {
  connect() {
    this.onKeydown = (event) => {
      if (event.key === "Escape") this.close()
    }
    document.addEventListener("keydown", this.onKeydown)

    this.tooltip = document.createElement("div")
    this.tooltip.className = "kit-sidebar-tooltip"
    document.body.appendChild(this.tooltip)

    // mouseover/mouseout (не mouseenter/mouseleave — те не всплывают)
    // делегированы с .kit-shell, чтобы не вешать по обработчику на каждую
    // ссылку сайдбара. Тултип рисуется в document.body с position:fixed —
    // .kit-sidebar__scroll имеет overflow-y:auto, а по спеке CSS это
    // автоматически превращает overflow-x в auto тоже, так что позиционный
    // тултип-потомок внутри сайдбара обрезался бы его границей.
    this.onLinkOver = (event) => {
      const link = event.target.closest(".kit-sidebar__link")
      if (!link || !this.element.contains(link)) return

      const label = link.querySelector("span")
      if (!label || getComputedStyle(label).display !== "none") return

      this.tooltip.textContent = label.textContent.trim()
      const rect = link.getBoundingClientRect()
      this.tooltip.style.top = `${rect.top + rect.height / 2}px`
      this.tooltip.style.left = `${rect.right + 10}px`
      this.tooltip.classList.add("is-visible")
    }

    this.onLinkOut = (event) => {
      const link = event.target.closest(".kit-sidebar__link")
      if (!link || link.contains(event.relatedTarget)) return
      this.tooltip.classList.remove("is-visible")
    }

    this.element.addEventListener("mouseover", this.onLinkOver)
    this.element.addEventListener("mouseout", this.onLinkOut)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
    this.element.removeEventListener("mouseover", this.onLinkOver)
    this.element.removeEventListener("mouseout", this.onLinkOut)
    this.tooltip?.remove()
  }

  toggle() {
    document.body.classList.toggle("sidebar-open")
  }

  close() {
    document.body.classList.remove("sidebar-open")
  }

  toggleCollapse() {
    const collapsed = document.documentElement.classList.toggle("sidebar-collapsed")
    try {
      localStorage.setItem(COLLAPSE_STORAGE_KEY, collapsed ? "1" : "0")
    } catch (e) {
      // localStorage может быть недоступен (приватный режим и т.п.)
    }
  }
}
